<template>
  <div class="rechargeCenter">
    <header>
      可用积分：
      <span class="integral_val">{{current_users_integral}}</span>
    </header>
    <div class="recharge">
      <div class="recharge_title">积分账户充值</div>
      <div class="recharge_secondary_title">选择充值积分数量</div>
      <div class="recharge_list">
        <div :class="['recharge_item', curIndex===index?'active':'']" v-for="(item, index) in list" :key="index" @click="switchItem(item,index)">
          <p>
            <span class="integral_val">{{item.integral}}</span>
            <span>积分</span>
          </p>
          <p>
            <span>售价 {{item.amount}}元</span>
          </p>
        </div>
      </div>
    </div>
    <footer>
      <div class="recharge_btn" @click="recharge">确认充值</div>
      <router-link :to="{path:'/rechargeCenter/record'}">
        <p class="recharge_record">查看充值记录</p>
      </router-link>
    </footer>
    <!--注册弹框-->
    <div class="store_modal">
      <van-dialog v-model="modal.show" :showConfirmButton="showConfirmButton">
        <div class="modal_title">
          <p>{{isRegister?'（园区商户职员）认证':'（商家）我要进驻'}}</p>
          <img class="modal_close_img"
               src="../../assets/images/integral/moadl_close.png"
               style="opacity: 0"
          >
        </div>
        <div class="modal_content">
          <p>您好，请拨打 <a style="text-decoration: underline;color: #027cdf;" href="tel:400-8008333">400-800-8333</a> 电话，</p>
          <p>或</p>
          <p>扫描添加以下微信号，与我们客服沟通联系</p>
          <img src="../../assets/images/integral/qr_code.jpg" alt="">
          <p class="Identify">长按识别</p>
        </div>
      </van-dialog>
    </div>
    <!--登录弹框-->
    <div class="login_modal store_modal">
      <van-dialog v-model="modal.login_show" :showConfirmButton="showConfirmButton">
        <div class="modal_title">
          <p class="login_title">登录领积分</p>
          <img class="modal_close_img"
               src="../../assets/images/integral/moadl_close.png"
               style="opacity: 0"
          >
        </div>
        <div class="modal_content">
          <div class="login_btn" @click="routerLinkto('/loginNormal')">
            马上登录
          </div>
        </div>
      </van-dialog>
    </div>
    <!--绑定弹框-->
    <div class="choose_moadl store_modal">
      <van-dialog v-model="modal.choose_show" :showConfirmButton="showConfirmButton">
        <div class="modal_title choose_title">
          <p>您的账号还未绑定园区商户</p>
          <img class="modal_close_img"
               src="../../assets/images/integral/moadl_close.png"
               style="opacity: 0"
          >
        </div>
        <div class="modal_content">
          <p class="content_des">说明 ：乐钢商城积分仅为园区内商户职员福利。加入我们，千万壕礼等你来兑！</p>
          <div class="choose_btn_box">
            <div class="choose_left_btn" @click="showCode(1)">
              我要入驻
              <div class="float_block">
                <div class="float_text">商家</div>
                <p class="block"></p>
              </div>
            </div>
            <div class="choose_right_btn" @click="showCode(2)">
              前往验证
              <div class="float_block">
                <div class="float_text">园区商户职员</div>
                <p class="block"></p>
              </div>
            </div>
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import config from '../../../setBaseUrl'
// import VConsole from 'vconsole'
export default {
  name: 'rechargeCenter',
  data () {
    return {
      is_login: true,
      isRegister: true,
      showConfirmButton: false,
      websocketUrl: config.websocketUrl,
      orderId: '', // 订单id
      current_users_integral: '', // 当前用户积分
      list: [], // 充值选项
      curIndex: 0, // 默认选中第一个
      chosenOne: {
        integral: '',
        amount: ''
      },
      modal: {
        show: false,
        login_show: false,
        choose_show: false
      }
    }
  },
  // created () {
  //   var vConsole = new VConsole()
  //   console.log(vConsole)
  // },
  mounted () {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.is_login = true
    } else {
      this.is_login = false
    }
    this.modal.login_show = !this.is_login
    this.initData()
    this.getUserIntegral()
  },
  methods: {
    initData () {
      /* 签到信息 */
      this.axios(this.$API.CONTINUOUS_SIGNIN_INFO).then(({ data }) => {
        this.is_continuous_sign_in = data.data.is_continuous_sign_in
        if (!this.is_continuous_sign_in && this.is_login) {
          this.modal.choose_show = true
        }
      })
    },
    /* 展示二维码 */
    showCode (type) {
      this.modal.choose_show = false
      this.modal.show = true
      this.isRegister = type === 2
    },
    recharge () {
      this.axios(this.$API.INTEGRAL_CREATE, {
        params: {
          amout: this.chosenOne.amount,
          integral: this.chosenOne.integral,
          source_type: 0
        }
      }).then((res) => {
        if (res.data.code === 1) {
          this.orderId = res.data.data
          const payObj = {
            order_id: this.orderId,
            type: 3, // 积分充值
            amout: this.chosenOne.amount,
            integral: this.chosenOne.integral,
            source_type: 0
          }
          console.log(payObj, '支付充值参数')
          this.axios.post(this.$API.PAY, payObj).then((res) => {
            if (res.data.code === 1) {
              // code为1，微信支付
              const jsApi = JSON.parse(res.data.data)
              // 微信支付参数
              const obj = {
                appId: jsApi.appId,
                timeStamp: jsApi.timeStamp,
                nonceStr: jsApi.nonceStr,
                package: jsApi.package,
                signType: jsApi.signType,
                paySign: jsApi.paySign
              }
              this.watchPayment()
              this.wxpay(obj)
            } else if (res.data.code === 302) {
              // code为302，余额支付或积分支付
              this.$router.push({
                name: 'rechargeResult',
                query: {
                  result: 1
                }
              })
            } else {
              this.$toast(res.data.msg)
              setTimeout(() => {
                this.$router.push({
                  name: 'rechargeResult',
                  query: {
                    result: 2
                  }
                })
              }, 2000)
            }
          })
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    /* eslint-disable */
    wxpay (json) {
      const vm = this
      function onBridgeReady () {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', json,
          function (res) {
            console.log(res, '微信支付信息')
            if (res.err_msg === 'get_brand_wcpay_request:ok') { // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
              console.log(res, '支付成功')
              vm.$router.push({
                name: 'rechargeResult',
                query: {
                  result: 1
                }
              })
              // 支付成功
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
              vm.$toast('支付过程中用户取消')
              console.log(res, '支付取消')
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              // vm.$toast('支付失败')
              console.log(res, '支付失败')
              vm.$router.push({
                name: 'rechargeResult',
                query: {
                  result: 2
                }
              })
            }
          }
        )
      }
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
          document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
        }
      } else {
        onBridgeReady()
      }
    },
    /* eslint-disable */
    watchPayment () {
      const vm = this
      const wsServer = this.websocketUrl
      const websocket = new WebSocket(wsServer)
      websocket.onopen = function (evt) {
        // type 1 订单支付 2 账户充值 3 积分充值
        const obj = {
          type: 3,
          id: vm.orderId
        }
        websocket.send(JSON.stringify(obj))
        console.log('Connected to WebSocket server.')
      }

      websocket.onclose = function (evt) {
        console.log('Disconnected')
      }

      websocket.onmessage = function (evt) {
        if (evt.data === '已经支付') {
          vm.$router.push({
            name: 'rechargeResult',
            query: {
              result: 1
            }
          })
        }
        console.log('Retrieved data from server: ' + evt.data)
      }

      websocket.onerror = function (evt, e) {
        console.log('Error occured: ' + evt.data)
      }
    },
    getUserIntegral () {
      this.axios(this.$API.GET_USER_INTEGRAL).then(res => {
        if (res.data.code === 1) {
          this.current_users_integral = res.data.data.current_users_integral
          this.list = res.data.data.lists
          this.chosenOne = this.list[this.curIndex]
        } else {
          this.$toast(res.data.msg)
        }
      })
    },
    switchItem (item, index) {
      this.chosenOne = item
      this.curIndex = index
    }
  }
}
</script>

<style lang="less" scoped>
  .store_modal /deep/ .van-dialog{
    width: 654px;
  }
  .store_modal{
    .modal_title{
      height: 120px;
      line-height: 120px;
      color: #2b2b2b;
      text-align: center;
      font-family: PingFang HK, PingFang HK-Medium;
      font-weight: bold;
      p{
        font-size: 32px;
        font-family: PingFang HK, PingFang HK-Medium;
      }
      img {
        width: 40px;
        height: 40px;
        position: absolute;
        right: 30px;
        top: 30px;
      }
      .login_title{
        margin-top: 30px;
      }
    }
    .modal_title.choose_title{
      margin-bottom: -30px;
    }
    .modal_content{
      text-align: center;
      font-size: 28px;
      .content_des{
        color: #9b9b9b;
        font-size: 28px;
        padding: 0 30px;
        text-align: left;
      }
      img{
        width: 292px;
        height: 292px;
        margin-top: 30px;
      }
      .Identify{
        color: #027cdf;
        font-size: 24px;
        height: 90px;
        line-height: 70px;
      }
      .login_btn{
        width: 280px;
        height: 88px;
        background-color: #027cdf;
        text-align: center;
        font-size: 28px;
        color: #ffffff;
        line-height: 90px;
        margin: 20px auto;
        border-radius: 10px;
        margin-bottom: 50px;
      }
      .choose_btn_box{
        padding: 48px 30px 40px 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .choose_left_btn{
          border: 2px solid #027cdf;
          color: #027cdf;
          position: relative;
          width: 276px;
          height: 88px;
          border-radius: 10px;
          text-align: center;
          line-height: 90px;
          font-size: 28px;
        }
        .choose_right_btn{
          background-color: #027cdf;
          color: #ffffff;
          position: relative;
          width: 276px;
          height: 88px;
          border-radius: 10px;
          text-align: center;
          line-height: 90px;
          font-size: 28px;
        }

        .float_block {
          position: absolute;
          right: 6px;
          top: -56px;
          .float_text {
            width: 180px;
            height: 40px;
            background-color: #ec310a;
            color: #ffffff;
            font-size: 24px;
            line-height: 42px;
            display: inline-block;
          }
          .block {
            display: inline-block;
            border-bottom: 6px solid #CB0000;
            border-right: 6px solid transparent;
            border-top: 6px solid transparent;
            border-left: 6px solid #CB0000;
          }
        }
      }
    }
  }
.rechargeCenter{
  font-family: PingFang TC, PingFang TC-Regular;
}
header{
  height: 88px;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 24px;
  font-size: 28px;
  color: #2b2b2b;
  margin-bottom: 16px;
  .integral_val{
    color: #027cdf;
  }
}
.recharge{
  height: calc(100vh - 104px);
  background-color: #ffffff;
  padding: 32px 24px;
  .recharge_title{
    font-size: 32px;
    font-family: PingFang HK, PingFang HK-Medium;
    font-weight: bold;
    color: #2b2b2b;
    margin-bottom: 8px;
  }
  .recharge_secondary_title{
    font-size: 28px;
    color: #9b9b9b;
    margin-bottom: 24px;
  }
  .recharge_list{
    display: flex;
    flex-wrap: wrap;
    .recharge_item{
      width: 206px;
      height: 130px;
      background: #ffffff;
      border: 2px solid #027cdf;
      border-radius: 8px;
      margin-right: 40px;
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      color: #027cdf;
      font-size: 24px;
      position: relative;
      &:nth-of-type(3n){
        margin-right: 0;
      }
      &::after{
        content: '';
        position: absolute;
        right: -1px;
        top: -1px;
        width: 48px;
        height: 48px;
        background: url('../../assets/images/recharge/recharge_selected.png') no-repeat;
        background-size: 100% 100%;
        display: none;
      }
      &.active{
        color: #e40505;
        border: 2px solid #ec310a;
        &::after{
          display: block;
        }
      }
      .selected_icon{
        position: absolute;
        right: 0;
        top: 0;
      }
      p+p{
        margin-top: 12px;
      }
      .integral_val{
        font-size: 32px;
      }
    }
  }
}
footer{
  width: 100%;
  position: fixed;
  bottom: 40px;
  left: 0;
  padding: 0 24px;
  .recharge_btn{
    width: 100%;
    height: 88px;
    background: #027cdf;
    border-radius: 8px;
    font-size: 32px;
    color: #ffffff;
    text-align: center;
    line-height: 88px;
    margin-bottom: 40px;
  }
  .recharge_record{
    font-size: 28px;
    color: #027cdf;
    text-align: center;
  }
}
</style>
